import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import Icon from '../forms/Icon';
import { generateId } from '../utility/functions';
import { SCREEN_MAX_WIDTH } from '../stateProvider/StateProvider';
import { TableContext } from './Table';

const Wrapper = styled.div`
    color: ${({ theme, active }) => active ? theme.contrast : theme.text};
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0.5em;
    cursor: pointer;
    border-radius: 10px;
    transition: background, 0.5s;
    position: relative;
    overflow: hidden;
    min-width: 13em;

    transition: background, color, 0.1s;
    background: ${({ active, color }) => active ? color : 'unset'};
    border: 2px solid ${({ active, color, theme }) => active ? color : theme.text};
    color: ${({ theme, active }) => active ? theme.contrast : theme.text};

    &:hover {
        background: ${({ color }) => color};
        border-color: ${({ color }) => color};
        color: ${({ theme }) => theme.contrast};
    }

    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        width: 43%;
        min-width: unset;
    }
`;

const Animation = styled.div`
    white-space: nowrap;
    transition: width, margin, .5s ease;
    padding: 0 0.5em;
`;
const Text = styled(Animation)`
    font-weight: 600;
    font-size: 1.1em;

    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        font-size: 0.8em;
    }
`;
const Number = styled(Animation)`
    font-weight: 600;
    font-size: 1.5em;
`;
const I = styled(Icon)`
    position: absolute;
    font-size: 1em;
    top: 0.1em;
    right: 0.1rem;
    opacity: ${({ active }) => active ? '1' : '0'};
    transition: opacity .3s ease;
`;
const rippleAnimation = keyframes`
    to {
        transform: scale(50);
        opacity: 0;
    }
`;
const Wave = styled.div`
    position: absolute;
    background-color: #ffffff66;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    transform: scale(0);
    pointer-events: none;
    animation: ${rippleAnimation} 0.6s linear;
`;

const QuickSort = ({ query, propKey, type, label, ...props }) => {
    const { master, filter, updateFilter, filterData } = useContext(TableContext);

    const QSP = { query, propKey, type };

    const buttonRef = useRef();
    const [wavePosition, setWavePosition] = useState({ x: null, y: null });

    const [active, setActive] = useState(false);
    const [id] = useState(generateId());
    const [numberResult, setNumberResult] = useState(0)

    useEffect(() => {
        if (props.defaultSearch) {
            setTimeout(() => handleClicked(), 50)
        }
    }, [])

    useLayoutEffect(() => setNumberResult(filterData([QSP], master).length), [master])

    useEffect(() => setActive(filter.find(e => e.id === id) ? true : false), [filter])

    const handleClicked = () => {
        updateFilter({
            id,
            query: !active ? query : null,
            propKey,
            type,
            label
        });
    }

    const handleWave = (e) => {
        setWavePosition({ x: null, y: null });
        const rect = buttonRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        setWavePosition({ x, y });
        setTimeout(() => setWavePosition({ x: null, y: null }), 600)
    };

    return (
        <Wrapper
            ref={buttonRef}
            color={props.color}
            onClick={handleClicked}
            onMouseDown={handleWave}
            active={active}
            key={id}
        >
            <Text active={active}>{label}</Text>
            <Number active={active}>{numberResult}</Number>
            <I active={active} icon='checkCircle' />
            {wavePosition.x !== null && (
                <Wave style={{ left: wavePosition.x, top: wavePosition.y }} />
            )}
        </Wrapper>
    );
}

export default QuickSort;